"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HyphenProvider = void 0;
const ethers_1 = require("ethers");
const logs_1 = require("../logs");
class HyphenProvider {
    constructor(params) {
        this.getProviderWithAccounts = (useBiconomy) => {
            return this.provider;
        };
        this.isBiconomyEnabled = params.isBiconomyEnabled;
        if (ethers_1.ethers.providers.Provider.isProvider(params.provider)) {
            logs_1.log.info(`Ethers provider detected`);
            this.provider = params.provider;
        }
        else {
            logs_1.log.info(`Non-Ethers provider detected`);
            this.provider = new ethers_1.ethers.providers.Web3Provider(params.provider);
        }
    }
    getCurrentNetwork() {
        return this.provider.getNetwork();
    }
    getProvider(useBiconomy) {
        return this.provider;
    }
    async getNetworkId() {
        const currentNetwork = await this.getCurrentNetwork();
        return currentNetwork.chainId;
    }
}
exports.HyphenProvider = HyphenProvider;
